import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity } from '@pit/core';
import { IDtoContact } from '../interfaces/dto.contact.interface';

// @dynamic
@JsonObject('DtoContact')
export class DtoContact extends ModelEntity implements IDtoContact {

    constructor(initValues: Partial<IDtoContact> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('name', String, true)
    public name?: string = null;

    @JsonProperty('phone', String, true)
    public phone?: string = null;

}
